import { getCookie, getUsersCurrentLocation } from "./helpers.js";
const existingAddress = getCookie("postal");
if (!existingAddress) {
  getUsersCurrentLocation((postalCode) => {
    const postalHeader = document.getElementsByClassName("header-postal-code")
      .length
      ? document.getElementsByClassName("header-postal-code")[0]
      : null;
    const postalHeaderTxt = postalHeader
      ? postalHeader.querySelector(".icon-label")
      : null;
    if (postalHeaderTxt) {
      postalHeaderTxt.innerHTML = postalCode;
    }
  }, true, false, true);
}
